export enum AspectRatio {
  "Auto" = "auto",
  "1:1" = "1/1",
  "2:1" = "2/1",
  "4:3" = "4/3",
  "16:9" = "16/9",
  "16:10" = "16/10",
  "21:9" = "21/9",
}

export enum MediaPosition {
  Left = "LEFT",
  Center = "CENTER",
  Right = "RIGHT",
}

export enum MediaVerticalPosition {
  Top = "TOP",
  Middle = "CENTER",
  Bottom = "BOTTOM",
}

export enum MediaSize {
  Standard = "STANDARD",
  Page = "PAGE",
}

export enum ImageVariant {
  Square = "SQUARE",
  Circle = "CIRCLE",
}

export enum ImageSize {
  Contain = "FIT",
  Cover = "FILL",
}

export enum ImageDisplayVariant {
  Static = "STATIC",
  Overlay = "OVERLAY",
}

export enum BackgroundImageAnchor {
  None = "NONE",
  Left = "LEFT",
  Right = "RIGHT",
}

export enum BackgroundImageAttachment {
  Fixed = "FIXED",
  Scroll = "SCROLL",
}

export enum VideoSource {
  Core = "CORE",
  Vimeo = "VIMEO",
  Wistia = "WISTIA",
  YouTube = "YOUTUBE",
}

export enum VideoDisplayVariant {
  Overlay = "OVERLAY",
  PlayInPlace = "PLAY_IN_PLACE",
  NewWindow = "NEW_WINDOW",
}

export enum OverlayVariant {
  Variant1 = "VARIANT_1",
  Variant2 = "VARIANT_2",
}

export enum SocialIconType {
  Twitter = "twitter",
  LinkedIn = "linkedin",
  Instagram = "instagram",
  Facebook = "facebook",
  YouTube = "youtube",
  Blog = "blog",
  Artsy = "artsy",
  Flickr = "flickr",
  TikTok = "tiktok",
  Threads = "threads",
  Streamly = "streamly",
  WhatsApp = "whatsapp",
}
